export default function Contact() {
  return (
    <section id="contact" className="py-24 bg-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Visit Us
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Walk-ins welcome at our Wichita location. No appointment necessary.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-16">
          <div className="bg-gray-900 p-8 rounded-2xl border border-gray-800">
            <div className="flex items-start gap-4 mb-6">
              <div className="w-12 h-12 flex items-center justify-center bg-red-600 rounded-lg flex-shrink-0">
                <i className="ri-map-pin-line text-2xl text-white"></i>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-white mb-2">
                  Justin's Location
                </h3>
                <p className="text-gray-400 text-lg">
                  551 West Douglas Ave<br />
                  Wichita, KS
                </p>
              </div>
            </div>

            <div className="aspect-video w-full rounded-xl overflow-hidden mb-6">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3151.8634!2d-97.3476!3d37.6872!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x87badb4e0e0e0e0e%3A0x0!2s551+W+Douglas+Ave%2C+Wichita%2C+KS!5e0!3m2!1sen!2sus!4v1234567890"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Main Location Map"
              ></iframe>
            </div>

            <div className="space-y-4">
              <div className="flex items-center gap-3">
                <i className="ri-phone-line text-red-500 text-xl"></i>
                <a 
                  href="tel:3163057076"
                  className="text-gray-300 hover:text-red-500 transition-colors cursor-pointer text-lg"
                >
                  (316) 305-7076
                </a>
              </div>
              <div className="flex items-center gap-3">
                <i className="ri-mail-line text-red-500 text-xl"></i>
                <a 
                  href="mailto:justin@anotherpiercingco.com"
                  className="text-gray-300 hover:text-red-500 transition-colors cursor-pointer text-lg break-all"
                >
                  justin@anotherpiercingco.com
                </a>
              </div>
            </div>
          </div>

          <div className="bg-gray-900 p-8 rounded-2xl border border-gray-800">
            <div className="flex items-start gap-4 mb-6">
              <div className="w-12 h-12 flex items-center justify-center bg-red-600 rounded-lg flex-shrink-0">
                <i className="ri-map-pin-line text-2xl text-white"></i>
              </div>
              <div>
                <h3 className="text-2xl font-bold text-white mb-2">
                  Tia's Location
                </h3>
                <p className="text-gray-400 text-lg">
                  8663 West Central<br />
                  Wichita, KS
                </p>
              </div>
            </div>

            <div className="aspect-video w-full rounded-xl overflow-hidden mb-6">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3150.234!2d-97.4856!3d37.6912!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzfCsDQxJzI4LjMiTiA5N8KwMjknMDguMiJX!5e0!3m2!1sen!2sus!4v1234567891"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Tia's Location Map"
              ></iframe>
            </div>

            <div className="space-y-4">
              <div className="flex items-center gap-3">
                <i className="ri-phone-line text-red-500 text-xl"></i>
                <a 
                  href="tel:3168807760"
                  className="text-gray-300 hover:text-red-500 transition-colors cursor-pointer text-lg"
                >
                  (316) 880-7760
                </a>
              </div>
              <div className="flex items-center gap-3">
                <i className="ri-mail-line text-red-500 text-xl"></i>
                <a 
                  href="mailto:TiaTNTtheneedletemptress@gmail.com"
                  className="text-gray-300 hover:text-red-500 transition-colors cursor-pointer text-lg break-all"
                >
                  TiaTNTtheneedletemptress@gmail.com
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-gray-900 p-8 rounded-2xl border border-gray-800">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-red-600 rounded-xl mx-auto mb-4">
                <i className="ri-time-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-2">
                Walk-Ins Welcome
              </h3>
              <p className="text-gray-400">
                No appointment needed. Visit us during business hours.
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-red-600 rounded-xl mx-auto mb-4">
                <i className="ri-shield-check-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-2">
                Safety Certified
              </h3>
              <p className="text-gray-400">
                Strict sterilization protocols and professional standards.
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 flex items-center justify-center bg-red-600 rounded-xl mx-auto mb-4">
                <i className="ri-vip-diamond-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-white mb-2">
                Jewelry Included
              </h3>
              <p className="text-gray-400">
                Premium jewelry included with every piercing service.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
